import { useCallback, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext.js';
import { ProfileApiDocsBodyStyled } from './styled/ProfileStyled';

interface ProfileApiDocsModalProps {
    show: boolean;
    onHide: () => void;
}

function ProfileApiDocsModal({ show, onHide }: ProfileApiDocsModalProps) {
    const { getLangPath } = useLangContext();

    return (
        <Modal show={show} onHide={onHide} centered size="lg" contentClassName="app-form-modal">
            <Modal.Header closeButton>
                <Modal.Title>{getLangPath('profile.api_docs.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProfileApiDocsBodyStyled>
                    <div className="docs-section">
                        <h3>{getLangPath('profile.api_docs.overview_title')}</h3>
                        <p>{getLangPath('profile.api_docs.overview_body')}</p>
                    </div>

                    <div className="docs-section">
                        <h3>{getLangPath('profile.api_docs.credentials_title')}</h3>
                        <p>{getLangPath('profile.api_docs.credentials_body')}</p>
                        <ul>
                            <li>
                                <strong>{getLangPath('profile.partner_id')}</strong>
                                {' — '}
                                {getLangPath('profile.api_docs.credentials_partner_id')}
                            </li>
                            <li>
                                <strong>{getLangPath('profile.api_key')}</strong>
                                {' — '}
                                {getLangPath('profile.api_docs.credentials_api_key')}
                            </li>
                        </ul>
                    </div>

                    <div className="docs-section">
                        <h3>{getLangPath('profile.api_docs.tracking_title')}</h3>
                        <p>{getLangPath('profile.api_docs.tracking_body')}</p>
                        <pre className="docs-example">{getLangPath('profile.api_docs.tracking_example')}</pre>
                        <p>{getLangPath('profile.api_docs.tracking_params')}</p>
                    </div>

                    <div className="docs-section">
                        <h3>{getLangPath('profile.api_docs.postbacks_title')}</h3>
                        <p>{getLangPath('profile.api_docs.postbacks_body')}</p>
                        <ul>
                            <li>
                                <code>click</code>
                                {' — '}
                                {getLangPath('profile.api_docs.postbacks_click')}
                            </li>
                            <li>
                                <code>registration</code>
                                {' — '}
                                {getLangPath('profile.api_docs.postbacks_registration')}
                            </li>
                            <li>
                                <code>ftd</code>
                                {' — '}
                                {getLangPath('profile.api_docs.postbacks_ftd')}
                            </li>
                            <li>
                                <code>deposit</code>
                                {' — '}
                                {getLangPath('profile.api_docs.postbacks_deposit')}
                            </li>
                            <li>
                                <code>turnover</code>
                                {' — '}
                                {getLangPath('profile.api_docs.postbacks_turnover')}
                            </li>
                        </ul>
                        <p>{getLangPath('profile.api_docs.postbacks_tokens')}</p>
                        <pre className="docs-example">{getLangPath('profile.api_docs.postbacks_example')}</pre>
                    </div>

                    <div className="docs-section">
                        <h3>{getLangPath('profile.api_docs.security_title')}</h3>
                        <p>{getLangPath('profile.api_docs.security_body')}</p>
                    </div>
                </ProfileApiDocsBodyStyled>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide}>
                    {getLangPath('profile.api_docs.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export function useProfileApiDocsModal() {
    const [show, setShow] = useState(false);
    const open = useCallback(() => setShow(true), []);
    const close = useCallback(() => setShow(false), []);
    return { show, open, close };
}

export default ProfileApiDocsModal;
